import * as actionTypes from './actionTypes';

export default (reload = false) => (dispatch) => {
  dispatch({
    type: actionTypes.GLOBAL_ERROR_DISMISSED,
  });
  if (reload) {
    window.location.reload();
  }
};
